export { WatermarkPositions } from './WatermarkPositions';
export { defaultWatermarkPostion, watermarkPositions } from './WatermarkPositionTypes';
